import React from 'react';

interface ComponentTitleProps {
  title: string;
  subtitle?: string;
  showTitle?: boolean;
  className?: string;
  rightButton?: {
    icon: React.ReactNode;
    onClick: () => void;
    title?: string;
  };
}

/**
 * 统一的组件标题组件
 * 为所有时钟模式组件提供一致的标题样式
 */
export const ComponentTitle: React.FC<ComponentTitleProps> = ({
  title,
  subtitle,
  showTitle = true,
  className = '',
  rightButton
}) => {

  if (!showTitle) {
    return null;
  }

  return (
    <div className={`mb-3 ${className} ${rightButton ? 'flex items-center justify-between' : 'text-center'}`}>
      <div className={rightButton ? 'flex-1' : ''}>
        <h4 className="text-sm font-medium mb-1">
          {title}
        </h4>
        {subtitle && (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {subtitle}
          </p>
        )}
      </div>

      {rightButton && (
        <button
          onClick={rightButton.onClick}
          className="ml-2 px-2 py-1 rounded-md bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-xs text-gray-600 dark:text-gray-300"
          title={rightButton.title}
        >
          {rightButton.icon}
        </button>
      )}
    </div>
  );
};

export default ComponentTitle;
